import { render, staticRenderFns } from "./ReviewPlacementTestResult.vue?vue&type=template&id=86f2bd44&"
import script from "./ReviewPlacementTestResult.vue?vue&type=script&lang=js&"
export * from "./ReviewPlacementTestResult.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlacementTestResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports